<template>
    <div v-if="bizAuth.viewWallet.hasRight" class="page-setting biz-wallet parent-frame" :class="{'fixed': listIsFixed}" v-bind:style="{'min-height': myHeight}">
        <platform-fee-info></platform-fee-info>
        <wallet-stored-info></wallet-stored-info>
        <wallet-withdraw></wallet-withdraw>
        <div class="tool-bar-mask"></div>
        <div class="page-header  has-tab">
            <h1>
                {{$route.meta.title}}
                <div class="platform-fee" @click="platformFeeEvent()">
                    <img src="@/assets/img/icon/info_gray.svg" alt="" srcset="">
                    <div class="info">
                        收費說明
                    </div>
                </div>
            </h1>
            <div class="btn-group">
                <div class="stored">
                    <div class="money">
                        <span class="sign">
                            帳戶餘額
                        </span>
                        <div class="number">
                            {{toCurrency(userTotalBalance)}}
                        </div>
                    </div>
                    
                </div>
                <button class="border-button publish" @click="storedWallet()">儲值</button>
                <button v-if="bizAuth.createWithdraw.hasRight" class="default-button publish" @click="walletWithdraw()">提領</button>
            </div>
        </div>
        <tabs :key="componentKey">
            <tab name="全部" :selected="selected.all" >
                <all-trans-record-comp></all-trans-record-comp>
            </tab>
            <tab name="提領紀錄" :selected="selected.withdraw" >
                <withdraw-record-comp></withdraw-record-comp>
            </tab>
            <tab name="收款帳戶" :selected="selected.bank" >
                <recive-account-comp></recive-account-comp>
            </tab>
        </tabs>
        <!-- <contract-setting-comp :submit="submitEnt" :preview="previewEnt"></contract-setting-comp> -->
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import allTransRecordComp from '@/components/bussiness/settingCenter/wallet/allTransRecord/allTransRecordComp.vue';
import reciveAccountComp from '@/components/bussiness/settingCenter/wallet/reciveAccount/reciveAccountComp.vue';
import withdrawRecordComp from '@/components/bussiness/settingCenter/wallet/withdrawRecord/withdrawRecordComp.vue';
import platformFeeInfo from '@/components/widge/modal/platformFeeInfo.vue';
import walletStoredInfo from '@/components/bussiness/widges/modals/walletStoredInfo.vue';
import walletWithdraw from '@/components/bussiness/widges/modals/walletWithdraw.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            selected: {
                all: false,
                withdraw: false,
                bank: false,
            },
            componentKey: 0,
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
        this.$store.dispatch('getBizGetWallet')
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
            },
            immediate: true,
            deep: true
        },
        'bizAuth.viewWallet.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        platformFeeEvent: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'platformFeeInfo'})
            this.$analyticsBiz.logEvent('平台收費說明', { screen_name: '平台收費說明'})
        },
        storedWallet: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizWalletStoredInfo'})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        walletWithdraw: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizWalletWithdraw'})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            if( hashTag == '#全部' ){
                this.selected.all = true
            }else if( hashTag == '#提領紀錄' ){
                this.selected.withdraw = true
            }else if( hashTag == '#收款帳戶' ){
                this.selected.bank = true
            }else{
                this.selected.all = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.all = false
            this.selected.withdraw = false
            this.selected.bank = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            userTotalBalance: 'GET_BIZ_TOTAL_BALANCE',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        Tabs,
        Tab,
        allTransRecordComp,
        reciveAccountComp,
        withdrawRecordComp,
        platformFeeInfo,
        walletStoredInfo,
        walletWithdraw
    }
}
</script>
<style lang="scss">
    .biz-wallet{
        .platform-fee{
            position: relative;
            display: flex;
            align-items: center;
            font-size: 12px;
            cursor: pointer;
            margin-left: 8px;
            top: 2px;
            .info{
                font-size: 12px;
                line-height: 24px;
                color: #a19d9c;
            }
            img{
                margin-right: 2px;
            }
        }
        .btn-group{
            >button{
                margin-left: 10px;
            }
            .stored{
                margin-right: 15px;
                position: relative;
                display: flex;
                .money{
                    position: relative;
                    display: flex;
                    align-items: center;
                    .sign{
                        color: #292625;
                        margin-right: 4px;
                    }
                    .number{
                        color: #ff9275;
                        margin-left: 6px;
                        margin-right: 6px;
                        font-size: 28px;
                    }
                }
                
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/settingCenter/wallet/walletDefault.vue